<template>
  <div>
    <SensorData v-if="sensor"/>
    <div class="text-center">
      <Button :href="airMapUrl">
        <Icon :icon="['fas', 'fa-map', 'mr-2 text-gray-500']"/>
        {{$t('widget.go_to_map')}}
      </Button>
    </div>
  </div>
</template>

<script>
import SensorData from '@/components/molecules/SensorData';
import Icon from '@/components/atoms/Icon';
import Button from '@/components/atoms/Button';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Widget',
  components: {
    SensorData,
    Icon,
    Button,
  },

  data() {
    return {
      airMapUrl: `${window.location.origin}/${this.$route.params.lang}/${this.$route.params.id}`,
    };
  },

  computed: {
    ...mapGetters([
      'sensor',
    ]),
  },

  mounted() {
    this.getSensor(this.$route.params.id);
  },

  methods: {
    ...mapActions([
      'getSensor',
    ]),
  },
};
</script>

<style lang="scss">
html,
body {
  min-width: 200px;
}
</style>

